import { render, staticRenderFns } from "./BudgetSectionModal.vue?vue&type=template&id=28a7a2c6&"
import script from "./BudgetSectionModal.vue?vue&type=script&lang=js&"
export * from "./BudgetSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports